import React from "react";
import { getValue } from "../../utils";
import { Div } from "components/Base";
import Tooltip from "components/Global/Tooltip";

const CONTAINER_STYLES = {
  display: "flex",
  gap: "4px",
  alignItems: "center",
  cursor: "default"
};

const TEXT_CONTAINER_STYLES = {
  borderRadius: "4px",
  padding: "4px 8px",
  display: "flex",
  gap: "6px",
  border: "1px solid #E7E6EA",
  alignItems: "center"
};

const COLOR_STYLES = {
  width: "8px",
  height: "8px",
  borderRadius: "1px"
};

const TEXT_STYLES = {
  color: "#494949",
  fontSize: "12px",
  fontWeight: "400"
};

const ContentTags = props => {
  const value = getValue(props);
  if (!value.length) return "-";
  return (
    <Div style={CONTAINER_STYLES}>
      <Div style={TEXT_CONTAINER_STYLES}>
        <Div
          style={{
            ...COLOR_STYLES,
            background: value[0].color
          }}
        />
        <span style={TEXT_STYLES}>{value[0].label}</span>
      </Div>
      {value.length > 1 && (
        <Tooltip
          tooltip={value
            .slice(1)
            .map(tag => tag.label)
            .join(", ")}
        >
          <span>{`+${value.length - 1}`}</span>
        </Tooltip>
      )}
    </Div>
  );
};

export default ContentTags;
